import { getQueryString } from "utils/getQueryString";
import axios from "../axios";

const getAll = (queryParams) => {
  return axios.get(`/annual-returns?${getQueryString(queryParams)}`);
};

const create = (data) => {
  return axios.post("/annual-returns", data);
};

const update = (annualReturnId, data) => {
  return axios.put(`/annual-returns/${annualReturnId}`, data);
};

const get = (annualReturnId) => {
  return axios.get(`/annual-returns/${annualReturnId}`);
};
const remove = (companyId) => axios.delete(`/companies/${companyId}`);

const annualReturnDataService = {
  getAll,
  create,
  update,
  get,
  remove,
};

export default annualReturnDataService;
